import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { usersApi } from "../../api/Instances";
const END_POINT = process.env.REACT_APP_BASE_URL_PERMISSIONS;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}
const empty = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}

export const postRole = (state, setLoad) => {
    return async (dispatch) => {
        setLoad(true);
        try {
            const response = await usersApi.post(`/api/roles`, state);
            if (response.data.status === "Success") {
                dispatch(add(types.ADD_ROLE));
                dispatch(loadRoles());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error creating role");
        } finally {
            setLoad(false);
        }
    };
};

export const loadRoles = () => {
    return async (dispatch) => {
        try {
            const response = await usersApi.get(`/api/roles`);
            if (response.data.status === "Success") {
                dispatch(get(response.data.data, types.GET_ROLES));
            }
        } catch (error) {
            console.error("Error loading roles:", error.response?.data?.message || error.message);
        }
    };
};

export const loadPermissionsByRole = (id) => {
    return async (dispatch) => {
        try {
            const response = await usersApi.get(`/api/roles/${id}/edit`);
            if (response.data.status === "Success") {
                dispatch(get(response.data.data, types.GET_PERMISSIONS_BY_ROLE));
            }
        } catch (error) {
            console.error("Error loading permissions by role:", error.response?.data?.message || error.message);
            notifyError(error.response?.data?.message || "Error loading permissions");
        }
    };
};

export const emptyPermission = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(empty(emptyy, types.EMPTY_PERMISSIONS_BY_ROLE))
    }
}

export const loadMainPermission = (setStatusLoading) => {
    return async (dispatch) => {
        setStatusLoading(true);
        try {
            const response = await usersApi.get(`/api/roles/permissions/user`);
            if (response.data.status === "Success") {
                dispatch(get(response.data.data, types.GET_MAIN_PERMISSIONS));
            }
        } catch (error) {
            console.error("Error loading main permissions:", error.response?.data?.message || error.message);
            hasExpirition(error.response?.data?.returnedCode || "Session expired");
        } finally {
            setStatusLoading(false);
        }
    };
};

export const putPermission = (role_id, name, status, setLoadStatusID) => {
    return async (dispatch) => {
        setLoadStatusID(true);
        try {
            const response = await usersApi.put(
                `/api/roles/${role_id}/permissions?permission=${name}&status=${status}`
            );
            if (response.data.status === "Success") {
                notifysuccess(response.data.message);
                dispatch(edit(types.EDIT_PERMISSIONS));
                dispatch(loadPermissionsByRole(role_id));
            }
        } catch (error) {
            console.error("Error updating permission:", error.response?.data?.message || error.message);
            notifyError(error.response?.data?.message || "Error updating permission");
        } finally {
            setLoadStatusID(false);
        }
    };
};
